/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestDbRes } from '../../models/test-db-res';

export interface ApiServerTestTryChempmmspendGet$Params {
  secret?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiServerTestTryChempmmspendGet(http: HttpClient, rootUrl: string, params?: ApiServerTestTryChempmmspendGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDbRes>> {
  const rb = new RequestBuilder(rootUrl, apiServerTestTryChempmmspendGet.PATH, 'get');
  if (params) {
    rb.query('secret', params.secret, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestDbRes>;
    })
  );
}

apiServerTestTryChempmmspendGet.PATH = '/api/server-test/try-chempmmspend';
